export const globalState = new Map();
